/**
 * @generated SignedSource<<919cf5835050c96f26f249e2140cba3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type batchQueryAbWidgetQuery$variables = {
  cftEntityIds: ReadonlyArray<string>;
  cftFirst: number;
  cftTopicEntityId?: string | null | undefined;
  includeStoryPackageOne: boolean;
  includeStoryPackageTwo: boolean;
  spotlightEntityIds: ReadonlyArray<string>;
  spotlightFirst: number;
  storyPackageOneEntityIds: ReadonlyArray<string>;
  storyPackageOneFirst: number;
  storyPackageOneTopicEntityId?: string | null | undefined;
  storyPackageTwoEntityIds: ReadonlyArray<string>;
  storyPackageTwoFirst: number;
  storyPackageTwoTopicEntityId?: string | null | undefined;
  withCftTopic: boolean;
  withStoryPackageOneTopic: boolean;
  withStoryPackageTwoTopic: boolean;
};
export type batchQueryAbWidgetQuery$data = {
  readonly cftTopic?: {
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  };
  readonly storyPackageOneTopic?: {
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  };
  readonly storyPackageTwoTopic?: {
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  };
  readonly widget1?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId?: string;
        readonly urlAlias?: string;
        readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "homeSecondaryV2ContentItemContent">;
      };
    }>;
  };
  readonly widget2?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId?: string;
        readonly urlAlias?: string;
        readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "homeSecondaryV2ContentItemContent">;
      };
    }>;
  };
  readonly widget3: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId?: string;
        readonly urlAlias?: string;
        readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "homeSecondaryV2ContentItemContent">;
      };
    }>;
  };
  readonly widget4: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId?: string;
        readonly urlAlias?: string;
        readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "homeSecondaryV2ContentItemContent">;
      };
    }>;
  };
};
export type batchQueryAbWidgetQuery = {
  response: batchQueryAbWidgetQuery$data;
  variables: batchQueryAbWidgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cftEntityIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cftFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cftTopicEntityId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStoryPackageOne"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStoryPackageTwo"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spotlightEntityIds"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spotlightFirst"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageOneEntityIds"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageOneFirst"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageOneTopicEntityId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageTwoEntityIds"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageTwoFirst"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageTwoTopicEntityId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withCftTopic"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withStoryPackageOneTopic"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withStoryPackageTwoTopic"
},
v16 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "storyPackageOneEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "storyPackageOneFirst"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v19 = {
  "kind": "Literal",
  "name": "withSize540x360",
  "value": true
},
v20 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "homeSecondaryV2ContentItemContent"
},
v21 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
},
v22 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "storyPackageOneTopicEntityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v23 = [
  (v21/*: any*/)
],
v24 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "storyPackageTwoEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "storyPackageTwoFirst"
  }
],
v25 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "withSize1200x800",
                    "value": true
                  },
                  (v19/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "contentCoverImageContent"
              },
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v26 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "storyPackageTwoTopicEntityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v27 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "cftEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "cftFirst"
  }
],
v28 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "cftTopicEntityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v29 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "spotlightEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "spotlightFirst"
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v35 = [
  (v32/*: any*/)
],
v36 = {
  "alias": "size1200x800",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1200x800"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v37 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v38 = [
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v42 = [
  (v41/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v17/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    },
    (v30/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v30/*: any*/)
  ],
  "storageKey": null
},
v47 = [
  (v17/*: any*/),
  (v30/*: any*/)
],
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v47/*: any*/),
  "storageKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v47/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v30/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v50/*: any*/),
    (v51/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v53 = [
  (v17/*: any*/)
],
v54 = {
  "kind": "InlineFragment",
  "selections": (v53/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v56 = {
  "kind": "InlineFragment",
  "selections": (v53/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v45/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v44/*: any*/),
            (v54/*: any*/),
            (v55/*: any*/),
            (v56/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v58/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v40/*: any*/),
        (v34/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": (v35/*: any*/),
          "storageKey": null
        },
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    (v30/*: any*/),
    (v43/*: any*/),
    (v18/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortName",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v44/*: any*/),
        (v45/*: any*/),
        (v46/*: any*/),
        (v48/*: any*/),
        (v49/*: any*/),
        (v52/*: any*/),
        (v59/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v44/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isSectionUnion"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v40/*: any*/),
            (v43/*: any*/)
          ],
          "type": "Section",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v40/*: any*/)
          ],
          "type": "VideoSection",
          "abstractKey": null
        },
        (v55/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v17/*: any*/),
            (v45/*: any*/),
            (v18/*: any*/),
            (v46/*: any*/),
            (v48/*: any*/),
            (v49/*: any*/),
            (v52/*: any*/),
            (v59/*: any*/)
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v68 = [
  (v67/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v67/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v54/*: any*/),
        (v56/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    (v45/*: any*/),
    (v46/*: any*/),
    (v48/*: any*/),
    (v49/*: any*/),
    (v52/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v72/*: any*/),
        (v58/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    (v44/*: any*/),
    (v17/*: any*/),
    (v45/*: any*/),
    (v18/*: any*/),
    (v46/*: any*/),
    (v48/*: any*/),
    (v49/*: any*/),
    (v52/*: any*/),
    (v59/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    (v50/*: any*/),
    (v51/*: any*/),
    (v74/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        (v74/*: any*/),
        (v30/*: any*/),
        (v75/*: any*/)
      ],
      "storageKey": null
    },
    (v57/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "multimediaEmbed",
      "plural": false,
      "selections": (v68/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v17/*: any*/),
            (v30/*: any*/),
            (v40/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVideoContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "leadingSlides",
      "plural": true,
      "selections": (v38/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        (v30/*: any*/),
        (v17/*: any*/)
      ],
      "storageKey": null
    },
    (v43/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v72/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "youtubeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v56/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
},
v78 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v30/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": (v38/*: any*/),
                "storageKey": null
              },
              (v39/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v44/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v73/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/)
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v79 = [
  (v30/*: any*/),
  (v75/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "batchQueryAbWidgetQuery",
    "selections": [
      {
        "condition": "includeStoryPackageOne",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "widget1",
            "args": (v16/*: any*/),
            "concreteType": "ArticleConnection",
            "kind": "LinkedField",
            "name": "articles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Article",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "withLandscape250x99",
                                "value": true
                              },
                              (v19/*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "contentCoverImageContent"
                          },
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "withStoryPackageOneTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "storyPackageOneTopic",
            "args": (v22/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "includeStoryPackageTwo",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "widget2",
            "args": (v24/*: any*/),
            "concreteType": "ArticleConnection",
            "kind": "LinkedField",
            "name": "articles",
            "plural": false,
            "selections": (v25/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "withStoryPackageTwoTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "storyPackageTwoTopic",
            "args": (v26/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "alias": "widget3",
        "args": (v27/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v25/*: any*/),
        "storageKey": null
      },
      {
        "condition": "withCftTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "cftTopic",
            "args": (v28/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "alias": "widget4",
        "args": (v29/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v25/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v15/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v13/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "batchQueryAbWidgetQuery",
    "selections": [
      {
        "alias": "widget3",
        "args": (v27/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v78/*: any*/),
        "storageKey": null
      },
      {
        "alias": "widget4",
        "args": (v29/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": (v78/*: any*/),
        "storageKey": null
      },
      {
        "condition": "includeStoryPackageOne",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "widget1",
            "args": (v16/*: any*/),
            "concreteType": "ArticleConnection",
            "kind": "LinkedField",
            "name": "articles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Article",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              {
                                "alias": "landscape250x99",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "landscape_250_99"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v35/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
                              },
                              (v37/*: any*/),
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v39/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v44/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/),
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v73/*: any*/),
                          (v76/*: any*/),
                          (v77/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "withStoryPackageOneTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "storyPackageOneTopic",
            "args": (v22/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v79/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "includeStoryPackageTwo",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "widget2",
            "args": (v24/*: any*/),
            "concreteType": "ArticleConnection",
            "kind": "LinkedField",
            "name": "articles",
            "plural": false,
            "selections": (v78/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "withStoryPackageTwoTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "storyPackageTwoTopic",
            "args": (v26/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v79/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "withCftTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "cftTopic",
            "args": (v28/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v79/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "87efe46d8da6f4541fff6f78b0726938",
    "id": null,
    "metadata": {},
    "name": "batchQueryAbWidgetQuery",
    "operationKind": "query",
    "text": "query batchQueryAbWidgetQuery(\n  $storyPackageOneEntityIds: [String!]!\n  $storyPackageOneFirst: Int!\n  $storyPackageOneTopicEntityId: String\n  $withStoryPackageOneTopic: Boolean!\n  $includeStoryPackageOne: Boolean!\n  $storyPackageTwoEntityIds: [String!]!\n  $storyPackageTwoFirst: Int!\n  $storyPackageTwoTopicEntityId: String\n  $withStoryPackageTwoTopic: Boolean!\n  $includeStoryPackageTwo: Boolean!\n  $cftEntityIds: [String!]!\n  $cftFirst: Int!\n  $cftTopicEntityId: String\n  $withCftTopic: Boolean!\n  $spotlightEntityIds: [String!]!\n  $spotlightFirst: Int!\n) {\n  widget1: articles(filter: {entityIds: $storyPackageOneEntityIds}, first: $storyPackageOneFirst) @include(if: $includeStoryPackageOne) {\n    edges {\n      node {\n        ... on Content {\n          __isContent: __typename\n          entityId\n          urlAlias\n          ...contentCoverImageContent_34Njms\n          ...homeSecondaryV2ContentItemContent\n          ...entityLink\n        }\n        id\n      }\n    }\n  }\n  storyPackageOneTopic: topic(filter: {entityId: $storyPackageOneTopicEntityId}) @include(if: $withStoryPackageOneTopic) {\n    ...entityLink\n    id\n  }\n  widget2: articles(filter: {entityIds: $storyPackageTwoEntityIds}, first: $storyPackageTwoFirst) @include(if: $includeStoryPackageTwo) {\n    edges {\n      node {\n        ... on Content {\n          __isContent: __typename\n          entityId\n          urlAlias\n          ...contentCoverImageContent_ScPJx\n          ...homeSecondaryV2ContentItemContent\n          ...entityLink\n        }\n        id\n      }\n    }\n  }\n  storyPackageTwoTopic: topic(filter: {entityId: $storyPackageTwoTopicEntityId}) @include(if: $withStoryPackageTwoTopic) {\n    ...entityLink\n    id\n  }\n  widget3: articles(filter: {entityIds: $cftEntityIds}, first: $cftFirst) {\n    edges {\n      node {\n        ... on Content {\n          __isContent: __typename\n          entityId\n          urlAlias\n          ...contentCoverImageContent_ScPJx\n          ...homeSecondaryV2ContentItemContent\n          ...entityLink\n        }\n        id\n      }\n    }\n  }\n  cftTopic: topic(filter: {entityId: $cftTopicEntityId}) @include(if: $withCftTopic) {\n    ...entityLink\n    id\n  }\n  widget4: articles(filter: {entityIds: $spotlightEntityIds}, first: $spotlightFirst) {\n    edges {\n      node {\n        ... on Content {\n          __isContent: __typename\n          entityId\n          urlAlias\n          ...contentCoverImageContent_ScPJx\n          ...homeSecondaryV2ContentItemContent\n          ...entityLink\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_1SslBT on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_ScPJx on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homeSecondaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  flag\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersCheckIsPlusArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_4u1L24\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_4u1L24 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1SslBT\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "92b8728da52f7671ee2f6598ca4f7f27";

export default node;
